import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';

/*
 * Component.
 */

export const CellSummaryPlaceholder: FC = () => (
  <em>
    <Trans id="cell-summary-placeholder">No content</Trans>
  </em>
);
